import { IUseFetchOptionsParams } from '@common/api.models';
import { FETCH_QUERIES_NAME } from '@common/constants';
import { createUseFetchOptionsNoPropsFn } from '@common/selectOptions.services';
import { getCompanyTypesAsync } from './companyType.services';

export const useFetchCompanyTypes = ({ isDirty = false, shouldConvertOptions = true }: IUseFetchOptionsParams) =>
  createUseFetchOptionsNoPropsFn({
    queryName: FETCH_QUERIES_NAME.COMPANY_TYPES,
    getOptionsFn: getCompanyTypesAsync,
    handleOptionsProps: {
      shouldConvertOptions,
      textFieldName: 'name',
    },
    enabled: !isDirty,
  });
